import { createContext } from 'react'

const AxInstructionsContext = createContext({})

export default AxInstructionsContext
